import { render, staticRenderFns } from "./UgcDetailComponent.vue?vue&type=template&id=415cfd4c&"
import script from "./UgcDetailComponent.vue?vue&type=script&lang=ts&"
export * from "./UgcDetailComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports